import React, { useEffect, useState } from 'react'

import { firestore } from '../../../firebase';
import EditSingleLeague from './Templates/EditSingleLeague';

function EditLeaguesAPI() {

    const [leagues, setLeagues] = useState([]);
    

    useEffect(() => {

        try {
            const leaguesRef = firestore.collection("top-leagues");
            leaguesRef.orderBy("order").onSnapshot(({docs}) => {
                const leagues = docs.map((doc) => {
                    const leagues = {id: doc.id, ...doc.data()}
                    return leagues
                })
                setLeagues(leagues)
            })
        } catch (error) {
            console.log(error)
        }

    }, [])



    return (

        <div>
            <h2 className="text-center font-weight-bold my-2">Rediger liga</h2>
            {leagues?.map((league, index) => {
                return <EditSingleLeague key={index} league={league} />
            })}
        </div>

    )

}
export default EditLeaguesAPI